import React from 'react';
import { getBordereauRemiseContext } from '@/contexts/BordereauRemiseContext';
import type { ModeReglementsPointageType } from '@/types';

const useBordereauRemise = (code: ModeReglementsPointageType) => {
  const SpecificContext = getBordereauRemiseContext(code);
  const context = React.useContext(SpecificContext);

  if (!context) {
    throw new Error(
      `BordereauRemiseContext not found for code: ${code}. Make sure the corresponding Provider is mounted.`,
    );
  }

  return context;
};

export default useBordereauRemise;
